import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from '@/components/auth/PrivateRoute';
import { MENU } from '@/constants/menuCodes';

const ApprovalDashboardPage = lazy(() => import('@/pages/approval/ApprovalDashboardPage'));
const ApprovalBoxPage = lazy(() => import('@/pages/approval/ApprovalBoxPage'));
const ApprovalDraftPage = lazy(() => import('@/pages/approval/ApprovalDraftPage'));
const ApprovalViewPage = lazy(() => import('@/pages/approval/ApprovalViewPage'));
const ApprovalSearchPage = lazy(() => import('@/pages/approval/ApprovalSearchPage'));
const ApprovalFormPage = lazy(() => import('@/pages/approval/ApprovalFormPage'));
const ApprovalRulePage = lazy(() => import('@/pages/approval/ApprovalRulePage'));
const ApprovalDelegationPage = lazy(() => import('@/pages/approval/ApprovalDelegationPage'));

/** 전자결재 모듈 라우트 */
const approvalRoutes = [
  // 최상단 '전자결재' 메뉴를 누르면 결재 대시보드가 열린다.
  <Route
    key="approval-root"
    path="approval"
    element={<PrivateRoute menuCode={MENU.APPR_INBOX}><ApprovalDashboardPage /></PrivateRoute>}
  />,
  <Route
    key="approval-dashboard"
    path="approval/dashboard"
    element={<PrivateRoute menuCode={MENU.APPR_INBOX}><ApprovalDashboardPage /></PrivateRoute>}
  />,

  <Route
    key="approval-draft-new"
    path="approval/draft"
    element={<PrivateRoute menuCode={MENU.APPR_DRAFT}><ApprovalDraftPage /></PrivateRoute>}
  />,
  <Route
    key="approval-draft-edit"
    path="approval/draft/:docId"
    element={<PrivateRoute menuCode={MENU.APPR_DRAFT}><ApprovalDraftPage /></PrivateRoute>}
  />,
  <Route
    key="approval-view"
    path="approval/view/:docId"
    element={<PrivateRoute menuCode={MENU.APPR_INBOX}><ApprovalViewPage /></PrivateRoute>}
  />,

  // 결재함 6종 — 같은 컴포넌트를 box 값만 바꿔 재사용한다.
  <Route
    key="approval-inbox"
    path="approval/inbox"
    element={<PrivateRoute menuCode={MENU.APPR_INBOX}><ApprovalBoxPage box="inbox" /></PrivateRoute>}
  />,
  <Route
    key="approval-progress"
    path="approval/progress"
    element={<PrivateRoute menuCode={MENU.APPR_PROGRESS}><ApprovalBoxPage box="progress" /></PrivateRoute>}
  />,
  <Route
    key="approval-completed"
    path="approval/completed"
    element={<PrivateRoute menuCode={MENU.APPR_COMPLETED}><ApprovalBoxPage box="completed" /></PrivateRoute>}
  />,
  <Route
    key="approval-rejected"
    path="approval/rejected"
    element={<PrivateRoute menuCode={MENU.APPR_REJECTED}><ApprovalBoxPage box="rejected" /></PrivateRoute>}
  />,
  <Route
    key="approval-drafted"
    path="approval/drafted"
    element={<PrivateRoute menuCode={MENU.APPR_DRAFTED}><ApprovalBoxPage box="drafted" /></PrivateRoute>}
  />,
  <Route
    key="approval-reference"
    path="approval/reference"
    element={<PrivateRoute menuCode={MENU.APPR_REFERENCE}><ApprovalBoxPage box="reference" /></PrivateRoute>}
  />,

  // 통합조회 — 메뉴 권한이 있으면 전체 결재문서를 조회한다.
  <Route
    key="approval-search"
    path="approval/search"
    element={<PrivateRoute menuCode={MENU.APPR_SEARCH}><ApprovalSearchPage /></PrivateRoute>}
  />,

  // 관리
  <Route
    key="approval-forms"
    path="approval/forms"
    element={<PrivateRoute menuCode={MENU.APPR_FORM}><ApprovalFormPage /></PrivateRoute>}
  />,
  <Route
    key="approval-rules"
    path="approval/rules"
    element={<PrivateRoute menuCode={MENU.APPR_RULE}><ApprovalRulePage /></PrivateRoute>}
  />,
  <Route
    key="approval-delegations"
    path="approval/delegations"
    element={<PrivateRoute menuCode={MENU.APPR_DELEGATION}><ApprovalDelegationPage /></PrivateRoute>}
  />,
];

export default approvalRoutes;
